import {
  DIRECTOR_POLITICALLY_EXPOSED,
  DIRECTOR_POLITICALLY_EXPOSED_REASON,
  DIRECTOR_PAN_CARD_DOCUMENT,
  DIRECTOR_PASSPORT_DOCUMENT,
  DIRECTOR_DIRECTOR_IDENTIFICATION_NUMBER,
  DIRECTOR_POSITION,
} from '@modifi/plugin-onboarding'

export const DIRECTOR_ROLES_PAGE_INPUT_FIELDS: string[] = [
  DIRECTOR_POSITION,
  DIRECTOR_DIRECTOR_IDENTIFICATION_NUMBER,
  DIRECTOR_PASSPORT_DOCUMENT,
  DIRECTOR_PAN_CARD_DOCUMENT,
  DIRECTOR_POLITICALLY_EXPOSED,
  DIRECTOR_POLITICALLY_EXPOSED_REASON,
]
